import Page from 'front/pages/Page/Page';
import * as _ from 'underscore';
import Urls from 'django_js_front/reverse.js';

import { VIEWPORT_EVENTS, REGEXPS } from '../../constants/Constants';

import './Order.less';
import * as Template from './Order.jinja';

const Selectors = {
    el: '.Order',
    selectList: '.Order-selectList',
    select: '.Order-selectListItem',
    checkbox: '.Order-formDeal',
    checkboxCircle: '.Order-formDeal-circle',
    sendButton: '.Order-formSend',
    content: '.Order-form-content',
    success: '.Order-form-success',
    textarea: '.Order-form-textarea',
    textareaPlaceholder: '.Order-form-textarea-placeholder',
    inputs: 'input[required], textarea[required]'
};

const BindFunctions = [
    'onResize',
    'onSelect',
    'onCheckbox',
    'onSend',
    'validateForm'
];

export default class Order extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.select}`]: this.onSelect,
            [`${VIEWPORT_EVENTS.click} ${Selectors.checkbox}`]: this.onCheckbox,
            [`${VIEWPORT_EVENTS.click} ${Selectors.sendButton}`]: this.onSend,
            [`focus ${Selectors.textarea}`]: this.onTextareaFocus,
            [`blur ${Selectors.textarea}`]: this.onTextareaBlur,
            [`input ${Selectors.textarea}`]: this.onTextareaInput,
            [`input ${Selectors.inputs}`]: this.validateForm
        };
    }

    constructor(options = {}) {
        options.el = Selectors.el;
        options.VIEWS_TO_REGISTER = {};
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        this.onResize();
        $(window).on(VIEWPORT_EVENTS.resize, this.onResize);
    }

    onTextareaFocus(e) {
        $(e.currentTarget).siblings(Selectors.textareaPlaceholder)
            .hide();
    }

    onTextareaBlur(e) {
        const $textarea = $(e.currentTarget);
        const $placeholder = $textarea.siblings(Selectors.textareaPlaceholder);
        if ($textarea.val().trim() === '') {
            $placeholder.show();
        }
    }

    onTextareaInput(e) {
        const $textarea = $(e.currentTarget);
        const $placeholder = $textarea.siblings(Selectors.textareaPlaceholder);
        if ($textarea.val().trim() !== '') {
            $placeholder.hide();
        } else {
            $placeholder.show();
        }
        this.validateForm();
    }

    onResize() {
        // let ww = window.innerWidth;
    }

    onSelect(e) {
        const $target = $(e.currentTarget);

        if ($target.hasClass('active')) {
            $target.removeClass('active');
        } else {
            $target.addClass('active');
        }
    }

    onCheckbox(e) {
        const $target = $(e.currentTarget);

        if ($target.children(Selectors.checkboxCircle).hasClass('active')) {
            $target.children(Selectors.checkboxCircle).removeClass('active');
        } else {
            $target.children(Selectors.checkboxCircle).addClass('active');
        }
        this.validateForm();
    }

    validateForm() {
        const allInputsFilled = this.$(Selectors.inputs).toArray()
            .every(input => input.value.trim() !== '');
        const checkboxChecked = this.$(Selectors.checkboxCircle).hasClass('active');
        const isValid = allInputsFilled && checkboxChecked;

        if (isValid) {
            this.$(Selectors.sendButton).addClass('active');
        } else {
            this.$(Selectors.sendButton).removeClass('active');
        }

        return isValid;
    }

    onSend() {
        if (!this.validateForm()) {
            return;
        }

        let name = this.$('input')[0];
        let email = this.$('input')[1];
        let phone = this.$('input')[2];
        let comment = this.$('textarea')[0];
        let $category = this.$('.Order-selectListItem.active');
        let categoryList = [];

        $category.map((i, item) => {
            categoryList.push(item.innerText);
        });

        let data = {
            name: name.value.toString(),
            email: email.value.toString(),
            phone: phone.value.toString(),
            comment: comment.value.toString(),
            category: categoryList.toString().replaceAll(',', ', '),
            createdAt: new Date(),
            state: 1,
            item: 1,
            params: ''
        };

        if (!data.email.match(REGEXPS.email)) {
            (app.settings.language === 'ru') ?
                alert('Некорректный Email') :
                alert('Incorrect Email');

            return;
        }

        if (!data.phone.match(REGEXPS.phone)) {
            (app.settings.language === 'ru') ?
                alert('Некорректный Телефон') :
                alert('Incorrect Phone');

            return;
        }

        data.params = this.getCookie('parametersArrived');

        this._xhr = $.ajax(Urls['front:api:callback']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify(data),
            'success': function () {
                this.$(Selectors.content).addClass('hidden');
                this.$(Selectors.success).addClass('show');
                this.$(Selectors.selectList).addClass('disabled');
            }.bind(this),
            'error': function () {
                (app.settings.language === 'ru') ?
                    alert('Произошла ошибка при оформлении заказа.' +
                        'Пожалуйста, свяжитесь с нами для решения проблемы. ' +
                        'bang@bangbangstudio.ru') :
                    alert('An error occured during checkout. ' +
                        'Please contact us to solve the problem. ' +
                        'bang@bangbangstudio.ru');
            }.bind(this)
        });
    }
}
